import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { PlatformApp } from "@taunggyi-plus/app-shell";
import { AuthProvider } from "@taunggyi-plus/auth";
import { getAppConfig, installPageZoomLock } from "@taunggyi-plus/config";
import { DeliveryRiderMore, CustomerInformationDialog } from "@taunggyi-plus/customer-feature";
import "@taunggyi-plus/design-system/styles.css";
import { RiderJobs } from "@taunggyi-plus/delivery-feature";
import { FinanceOverview } from "@taunggyi-plus/finance-feature";
import { NotificationCenter } from "@taunggyi-plus/notifications";

const authConfig = {
  appId: "delivery-rider",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

function DeliveryRiderDashboard() {
  return (
    <div className="role-dashboard role-dashboard--delivery-rider">
      <RiderJobs />
    </div>
  );
}

function DeliveryRiderOrders() {
  return (
    <div className="role-workspace role-workspace--delivery-rider-orders">
      <RiderJobs />
    </div>
  );
}

function DeliveryRiderFinance() {
  return (
    <div className="role-workspace role-workspace--delivery-rider-finance">
      <FinanceOverview role="delivery" />
    </div>
  );
}

installPageZoomLock();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <PlatformApp
        config={getAppConfig("delivery-rider")}
        informationContent={(locale, id, onClose) => (
          <CustomerInformationDialog locale={locale} id={id} onClose={onClose} />
        )}
        navigationMode="owner"
        dashboardContent={<DeliveryRiderDashboard />}
        ordersContent={<DeliveryRiderOrders />}
        financeContent={<DeliveryRiderFinance />}
        moreContent={(locale, onLocaleChange, onOpenPreferences) => (
          <DeliveryRiderMore
            locale={locale}
            onLocaleChange={onLocaleChange}
            onOpenPreferences={onOpenPreferences}
          />
        )}
        notificationContent={(locale) => (
          <NotificationCenter
            locale={locale}
            appId="delivery-rider"
            embedded
            webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
          />
        )}
      />
    </AuthProvider>
  </StrictMode>,
);
